import React from "react";
import Chip from "@material-ui/core/Chip";
import get from "lodash/get";

interface BooleanChipFieldProps {
  record?: any;
  source: string;
}

const BooleanChipField = ({ record = {}, source }: BooleanChipFieldProps) => {
  const status = get(record, source);
  return (
    <div>
      <Chip
        label={status ? "Enabled" : "Disabled"}
        style={{
          backgroundColor: status ? "#2196f3" : "#9e9e9e",
          color: "#FFF",
        }}
      />
    </div>
  );
};

export default BooleanChipField;
